import { FC, Fragment, ReactNode, useState } from "react";
import { Combobox, Dialog, Transition } from "@headlessui/react";
import { MagnifyingGlassIcon } from "@heroicons/react/20/solid";
import {
  ExclamationTriangleIcon,
  FolderIcon,
  LifebuoyIcon,
} from "@heroicons/react/24/outline";
import Image from "components/Image";
import { DEMO_AUTHORS } from "data/authors";
import { DEMO_CATEGORIES } from "data/taxonomies";
import { DEMO_POSTS } from "data/posts";
import Link from "components/Link";
import { useNavigate } from "react-router-dom";

type SearchItem = {
  id: number;
  href: string;
  title?: string;
  name?: string;
  displayName?: string;
  avatar?: string;
};

function classNames(...classes: string[]) {
  return classes.filter(Boolean).join(" ");
}

interface Props {
  renderTrigger?: () => ReactNode;
}

const SearchModal: FC<Props> = ({ renderTrigger }) => {
  const [open, setOpen] = useState(false);
  const [rawQuery, setRawQuery] = useState("a");

  const router = useNavigate();

  const query = rawQuery.toLowerCase().replace(/^[#>]/, "");

  const filteredPosts = DEMO_POSTS.filter((p) =>
    p.title.toLowerCase().includes(query)
  );

  const filteredProjects = DEMO_CATEGORIES.filter((c) =>
    c.name.toLowerCase().includes(query)
  );

  const filteredUsers = DEMO_AUTHORS.filter((u) =>
    u.displayName.toLowerCase().includes(query)
  );

  return (
    <>
      <div onClick={() => setOpen(true)} className="cursor-pointer">
        {renderTrigger ? renderTrigger() : <button>🔍</button>}
      </div>

      <Transition.Root show={open} as={Fragment}>
        <Dialog as="div" className="relative z-[99]" onClose={setOpen}>
          <div className="fixed inset-0 bg-black/40" />

          <div className="fixed inset-0 z-10 overflow-y-auto p-4 sm:p-6 md:p-20">
            <Dialog.Panel
              as="form"
              onSubmit={(e: React.FormEvent<HTMLFormElement>) => {
                e.preventDefault();
                router("/search");
                setOpen(false);
              }}
              className="mx-auto max-w-2xl rounded-xl bg-white shadow-2xl"
            >
              <Combobox
                onChange={(item: SearchItem) => {
                  router(item.href);
                  setOpen(false);
                }}
              >
                <div className="relative">
                  <MagnifyingGlassIcon className="absolute left-4 top-3.5 h-5 w-5 text-gray-400" />
                  <Combobox.Input
                    className="h-12 w-full pl-11"
                    placeholder="Search..."
                    onChange={(
                      event: React.ChangeEvent<HTMLInputElement>
                    ) => setRawQuery(event.target.value)}
                  />
                </div>
              </Combobox>
            </Dialog.Panel>
          </div>
        </Dialog>
      </Transition.Root>
    </>
  );
};

export default SearchModal;
